import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { BiRevision } from "react-icons/bi";
import "./style.css";
import { useHistory, useParams } from "react-router-dom";
import { MdPending } from "react-icons/md";
import {
  HiOutlineUser,
  HiOutlineTruck,
  HiOutlinePhotograph,
  HiOutlineCalendar,
  HiOutlineLocationMarker,
  HiOutlineClock,
} from "react-icons/hi";
import {
  CAR_DATA_UPDATE_STEPS,
  SET_APPOINTMENT_DATA,
  TOASTER_SHOW,
  toaster_w,
  CAR_DETAIL_UPDATE,
  GET,
} from "../../constant";
import axios from "axios";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import config from "../../config";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { scrollTop } from "../../utils/window";
import AppointmentEditModal from "../../components/AppointmentEditModal";
import CarUpdateWizard from "../CarUpdate/Wizard";
import RegPlate from "../../components/RegPlate";
import {
  getVehicleStepMetrics,
  countEvaluationPhotos,
  PHOTO_TARGET,
} from "../../utils/vehicleDetails";
import {
  getBookedAppointmentRecord,
  getAppointmentLocation,
  isPlaceholderAppointmentValue,
  appointmentBelongsToEvaluation,
  canEditBookedAppointment,
  formatAppointmentStatusLabel,
  resolveAppointmentStatus,
  getAppointmentStatusTone,
} from "../../utils/appointmentBooking";
import { formateTimeSlot } from "../../utils/formating";
import { resolveEvaluationPlateCountry } from "../../utils/plateCountry";
import { syncAuthCredits } from "../../utils/accountActivity";
import {
  getAuthCredits,
  getAuthToken,
  getAuthUserId,
} from "../../utils/userIdentity";
import Labels from "../../services/apiLabels";

const HERO_IMAGE = "/images/hero-car-steps.jpg";

function getEvaluationReg(evaluation) {
  if (!evaluation) {
    return "";
  }

  const reg = evaluation.reg_number ?? evaluation.car;
  if (reg == null || reg === "") {
    return "";
  }

  if (typeof reg === "object") {
    return "";
  }

  return String(reg).trim();
}

function StepCard({
  icon: Icon,
  title,
  description,
  statusLabel,
  statusVariant,
  progress,
  action,
  reloadOnTitle,
  onReload,
  details,
  suppressDescription,
  stepNumber,
}) {
  const hasDetails = Boolean(details);
  const safeProgress = Number.isFinite(progress)
    ? Math.min(100, Math.max(0, progress))
    : 0;
  const isComplete = safeProgress >= 100;
  const statusTone =
    statusVariant || (isComplete ? "complete" : "pending");
  const statusLooksDone =
    statusTone === "complete" ||
    statusTone === "completed" ||
    statusTone === "approved";

  return (
    <article
      className={`pi-car-steps__card pi-car-steps__card--${isComplete ? "complete" : "pending"}${
        hasDetails ? " pi-car-steps__card--has-summary" : ""
      }`}
    >
      <div className="pi-car-steps__card-panel">
        <div className="pi-car-steps__card-top">
          <div className="pi-car-steps__card-head">
            {stepNumber ? (
              <span
                className={`pi-car-steps__step-badge${
                  isComplete ? " is-complete" : ""
                }`}
                aria-hidden
              >
                {isComplete ? (
                  <BsFillCheckCircleFill size={14} />
                ) : (
                  stepNumber
                )}
              </span>
            ) : null}
            <div className="pi-car-steps__card-icon" aria-hidden>
              <Icon size={20} />
            </div>
            <div
              className={`pi-car-steps__progress-ring${
                isComplete ? " pi-car-steps__progress-ring--complete" : ""
              }`}
              style={{ "--pi-step-progress": `${safeProgress}%` }}
              aria-hidden
            >
              <span className="pi-car-steps__progress-ring-value">{safeProgress}%</span>
            </div>
          </div>

          <div className="pi-car-steps__card-body">
            <h2 className="pi-car-steps__card-title">
              {reloadOnTitle ? (
                <button
                  type="button"
                  className="pi-car-steps__reload"
                  onClick={onReload}
                  aria-label="Refresh"
                >
                  <BiRevision size={18} />
                </button>
              ) : null}
              <span>{title}</span>
            </h2>
            {!suppressDescription && description ? (
              <p className="pi-car-steps__card-desc">{description}</p>
            ) : null}
            {statusLabel ? (
              <span
                className={`pi-car-steps__status pi-car-steps__status--${statusTone}`}
              >
                {statusLooksDone ? (
                  <BsFillCheckCircleFill size={14} aria-hidden />
                ) : (
                  <MdPending size={14} aria-hidden />
                )}
                {statusLabel}
              </span>
            ) : null}
          </div>
        </div>

        {hasDetails ? (
          <div className="pi-car-steps__card-summary">{details}</div>
        ) : null}

        <div className="pi-car-steps__card-footer">
          <div className="pi-car-steps__progress-bar" role="presentation">
            <div
              className="pi-car-steps__progress-fill"
              style={{ width: `${safeProgress}%` }}
            />
          </div>
          <div className="pi-car-steps__card-action">{action}</div>
        </div>
      </div>
    </article>
  );
}

function AppointmentSummary({ location, date, time }) {
  const items = [
    location
      ? { key: "location", icon: HiOutlineLocationMarker, text: location }
      : null,
    date ? { key: "date", icon: HiOutlineCalendar, text: date } : null,
    time ? { key: "time", icon: HiOutlineClock, text: time } : null,
  ].filter(Boolean);

  if (!items.length) {
    return null;
  }

  return (
    <div className="pi-car-steps__appointment-strip" role="note">
      {items.map((item, index) => (
        <React.Fragment key={item.key}>
          {index > 0 ? (
            <span className="pi-car-steps__appointment-strip-sep" aria-hidden>
              ·
            </span>
          ) : null}
          <span className="pi-car-steps__appointment-strip-item">
            <item.icon size={14} aria-hidden />
            <span>{item.text}</span>
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

function StepActionButton({ className = "", children, onClick, type = "button", disabled = false }) {
  return (
    <button
      type={type}
      className={`pi-car-steps__btn ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export const CarSteps = (props) => {
  const { id } = useParams();
  const { feedback } = useContext(FeedbackContext);
  const car_steps_page = feedback?.car_steps_page || {};
  const {
    auth,
    step1,
    evaluation,
    evaluation_id_,
    book_appointmt_,
    vehicle_details,
    total_question,
    appoinments,
    appointment_create,
    vehicle_address,
    add_car_data,
    set_apointment_data,
    mycardata,
    car_data,
    plate_country,
    loadVehicleQuestions,
  } = props;
  const history = useHistory();

  const [api_loading, setapi_loading] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [isVehicleEdit, setVehicleEdit] = useState(false);
  const [isAppointmentEdit, setAppointmentEdit] = useState(false);
  const [contactSaving, setContactSaving] = useState(false);
  const [name, setName] = useState();
  const [email, setemail] = useState();
  const [number, setnumber] = useState();
  const [open_page, setopen_page] = useState(false);

  const baseUrl = `${config.baseUrl}api/v1/single_evaluate_details`;

  function loadData(evaluateId) {
    axios
      .post(baseUrl, {
        evaluate_id: evaluateId ?? evaluation_id_,
      })
      .then((response) => {
        const record = response?.data?.data?.[0];
        if (record) {
          add_car_data(record);
        }
        // Photos may debit credits in the pictures app — refresh wallet here.
        if (typeof props.syncCredits === "function") {
          props.syncCredits(auth);
        }
        setapi_loading(false);
      })
      .catch(() => {
        setapi_loading(false);
      });
  }

  useEffect(() => {
    scrollTop();
  }, []);

  const evaluateId = id || evaluation_id_ || evaluation?.id;

  useEffect(() => {
    if (!evaluateId) return undefined;
    setapi_loading(true);
    loadData(evaluateId);
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateId]);

  // Load vehicle questions so step progress is accurate (store is not persisted).
  useEffect(() => {
    if (!evaluateId || typeof loadVehicleQuestions !== "function") return undefined;
    loadVehicleQuestions(evaluation || {}, evaluateId);
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluateId]);

  // Refresh wallet when returning from the pictures app.
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      if (!evaluateId) return;
      if (typeof props.syncCredits === "function") {
        props.syncCredits(auth);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, evaluateId]);

  useEffect(() => {
    if (Array.isArray(mycardata) && mycardata.length > 0 && open_page) {
      history.push({
        pathname: "/myappointmentdetail",
        state: { index: 0, evaluationId: evaluation?.id },
      });
    }
  }, [mycardata, open_page, history]);

  function open_details() {
    setopen_page(true);
    set_apointment_data([evaluation]);
  }

  const update_userDetai = () => {
    if (contactSaving || !evaluation?.id) return;
    setContactSaving(true);
    axios
      .put(
        `${config.baseUrl}api/v1/update_evaluation_Details/${evaluation?.id}/`,
        {
          Website_user: name,
          Email: email,
          Mobile_number: number,
        }
      )
      .then((response) => {
        if (response.status == "200") setEdit(false);
        props.update_user_info(name, email, number, evaluation?.id);
      })
      .catch(() => {})
      .finally(() => {
        setContactSaving(false);
      });
  };

  const openVehicleEdit = () => {
    setEdit(false);
    setVehicleEdit(true);
    scrollTop();
  };

  const update_User = () => {
    setVehicleEdit(false);
    setName(evaluation?.Website_user);
    setnumber(evaluation?.Mobile_number);
    setemail(evaluation?.Email);
    setEdit(true);
  };

  const vehicleMetrics = getVehicleStepMetrics(
    vehicle_details,
    car_data,
    vehicle_address,
    total_question
  );
  const {
    complete: vehicleComplete,
    progress: vehicleProgress,
    answerableCount: answerableQuestionCount,
    answeredCount: answeredQuestionCount,
    hasAddress: hasVehicleAddress,
  } = vehicleMetrics;

  const getVehicleStatus = () => {
    if (vehicleComplete) {
      return { label: car_steps_page.Vehicle_Complate_text, variant: "complete" };
    }

    if (!vehicleMetrics.questionsLoaded && answerableQuestionCount === 0) {
      return {
        label: hasVehicleAddress
          ? "Checking vehicle questions…"
          : "Vehicle profile incomplete",
        variant: "pending",
      };
    }

    if (answerableQuestionCount > 0) {
      const progressLabel = `${answeredQuestionCount} of ${answerableQuestionCount} answered`;
      return {
        label: hasVehicleAddress
          ? progressLabel
          : `${progressLabel} · address pending`,
        variant: "pending",
      };
    }

    if (!hasVehicleAddress) {
      return { label: "Vehicle address not provided yet", variant: "pending" };
    }

    return { label: car_steps_page.Vehicle_Pending_text, variant: "pending" };
  };

  const getVehicleAction = () => {
    if (vehicleComplete) {
      return (
        <StepActionButton onClick={openVehicleEdit}>
          Edit
        </StepActionButton>
      );
    }
    return (
      <StepActionButton
        className="pi-car-steps__btn--outline"
        onClick={openVehicleEdit}
      >
        {answeredQuestionCount > 0 || hasVehicleAddress
          ? "Continue"
          : car_steps_page.Book_Appoinment_Start_text}
      </StepActionButton>
    );
  };

  const getAppointmentId = () => {
    const booked = getBookedAppointmentRecord(evaluation, appointment_create);
    if (booked?.id) {
      return booked.id;
    }
    if (Array.isArray(appoinments)) {
      const match = appoinments.find((item) => item?.id);
      if (match?.id) return match.id;
    }
    return null;
  };

  // Trust Redux booking success even if the carsteps refetch is briefly stale.
  const hasBookedAppointment = Boolean(
    getAppointmentId() ||
      (props.step3 &&
        appointmentBelongsToEvaluation(appointment_create, evaluation?.id))
  );

  // Prefer live image arrays on the current evaluation.
  // If image keys are missing (fresh create before refresh), stay at 0.
  const photoCount = evaluation?.id
    ? countEvaluationPhotos(evaluation)
    : 0;
  const photosComplete = photoCount >= PHOTO_TARGET;

  const goAppointment = () => {
    if (!hasBookedAppointment && !photosComplete) {
      props.showCreditsAlert?.({
        show: true,
        autoHide: true,
        type: toaster_w,
        heading: "Photos required",
        description:
          "Upload all 16 guided photos before booking an inspection appointment.",
      });
      return;
    }
    if (hasBookedAppointment) {
      const booked = getBookedAppointmentRecord(evaluation, appointment_create);
      if (!canEditBookedAppointment(booked)) {
        return;
      }
      setAppointmentEdit(true);
      scrollTop();
      return;
    }

    const credits = Number(getAuthCredits(auth));
    if (!Number.isFinite(credits) || credits <= 0) {
      props.showCreditsAlert?.({
        show: true,
        autoHide: true,
        type: toaster_w,
        heading: "No credits",
        description:
          "You have 0 credits. Please top up your credits before booking an appointment.",
      });
      return;
    }

    const target = book_appointmt_ ? "/bookappointmentnew" : "/bookappointment";
    history.push(target);
  };

  const appointmentComplete = hasBookedAppointment;
  const appointmentProgress = hasBookedAppointment ? 100 : 0;
  const bookedAppointment = getBookedAppointmentRecord(
    evaluation,
    appointment_create
  );

  const appointmentTimeLabel = bookedAppointment?.time_selected
    ? formateTimeSlot(bookedAppointment.time_selected)
    : "";
  const appointmentDateLabel =
    bookedAppointment?.date_selected || bookedAppointment?.date_applied || "";
  const appointmentLocation = getAppointmentLocation(bookedAppointment);

  const appointmentDetails =
    appointmentComplete && bookedAppointment ? (
      <AppointmentSummary
        location={appointmentLocation}
        date={
          isPlaceholderAppointmentValue(appointmentDateLabel)
            ? ""
            : appointmentDateLabel
        }
        time={
          isPlaceholderAppointmentValue(appointmentTimeLabel)
            ? ""
            : appointmentTimeLabel || bookedAppointment.time_selected
        }
      />
    ) : null;

  const canEditAppointment =
    appointmentComplete && canEditBookedAppointment(bookedAppointment);

  const vehicleStatus = getVehicleStatus();
  const showPhotosAndBooking = vehicleComplete;

  const journeySteps = [
    {
      key: "contact",
      icon: HiOutlineUser,
      title: car_steps_page.Contact_Details,
      description: car_steps_page.Your_Contact_Information,
      statusLabel: step1
        ? car_steps_page.Contact_Complate_text
        : car_steps_page.Contact_Pending_text,
      statusVariant: step1 ? "complete" : "pending",
      progress: step1 ? 100 : 0,
      action: step1 ? (
        <StepActionButton className="pi-car-steps__btn--outline" onClick={update_User}>
          Edit
        </StepActionButton>
      ) : (
        <StepActionButton className="pi-car-steps__btn--outline">
          {car_steps_page.Contact_Start_text}
        </StepActionButton>
      ),
    },
    {
      key: "vehicle",
      icon: HiOutlineTruck,
      title: car_steps_page.Vehicle_Details,
      description: car_steps_page.Vehicle_Information,
      statusLabel: vehicleStatus.label,
      statusVariant: vehicleStatus.variant,
      progress: vehicleProgress,
      action: getVehicleAction(),
    },
  ];

  if (showPhotosAndBooking) {
    const photoProgress = Math.round((photoCount / PHOTO_TARGET) * 100);
    journeySteps.push({
      key: "photos",
      icon: HiOutlinePhotograph,
      title: car_steps_page.Photos_text,
      description: step1 ? car_steps_page.Photos_desp1 : car_steps_page.Photos_desp2,
      statusLabel: `${photoCount} of ${PHOTO_TARGET} uploaded`,
      statusVariant: photosComplete ? "complete" : "pending",
      progress: photoProgress,
      reloadOnTitle: true,
      onReload: () => loadData(evaluateId),
      action: (
        <StepActionButton onClick={open_details}>See Pictures</StepActionButton>
      ),
    });
    journeySteps.push({
      key: "appointment",
      icon: HiOutlineCalendar,
      title: car_steps_page.Book_Appoinment_Details,
      description: photosComplete || appointmentComplete
        ? car_steps_page.Book_Appoinment_Information
        : "Complete photo uploads to unlock appointment booking.",
      suppressDescription: appointmentComplete,
      statusLabel: appointmentComplete
        ? formatAppointmentStatusLabel(bookedAppointment) || "Pending"
        : photosComplete
          ? car_steps_page.Book_AppoinmentPending_text
          : "Locked until photos complete",
      statusVariant: appointmentComplete
        ? getAppointmentStatusTone(
            resolveAppointmentStatus(bookedAppointment) || "pending"
          )
        : "pending",
      progress: appointmentProgress,
      details: appointmentDetails,
      action: appointmentComplete
        ? canEditAppointment ? (
            <StepActionButton
              className="pi-car-steps__btn--outline"
              onClick={goAppointment}
            >
              Edit
            </StepActionButton>
          ) : null
        : photosComplete ? (
            <StepActionButton
              className="pi-car-steps__btn--outline"
              onClick={goAppointment}
            >
              {car_steps_page.Vehicle_Start_text}
            </StepActionButton>
          ) : (
            <StepActionButton className="pi-car-steps__btn--outline" disabled>
              {car_steps_page.Vehicle_Start_text || "Start"}
            </StepActionButton>
          ),
    });
  }

  const completedSteps = journeySteps.filter((step) => (step.progress || 0) >= 100).length;
  const overallProgress = journeySteps.length
    ? Math.round((completedSteps / journeySteps.length) * 100)
    : 0;
  const vehicleReg = getEvaluationReg(evaluation);

  if (isAppointmentEdit) {
    return (
      <div className="pi-car-steps">
        <AppointmentEditModal
          appointmentId={getAppointmentId()}
          updateIndex={0}
          onClose={() => {
            setAppointmentEdit(false);
            if (evaluateId) {
              loadData(evaluateId);
            }
          }}
        />
      </div>
    );
  }

  return (
    <div className="pi-car-steps">
      <header className="pi-inner-hero pi-inner-hero--with-bar">
        <div className="pi-inner-hero__media" aria-hidden>
          <img
            className="pi-inner-hero__media-img"
            src={`${process.env.PUBLIC_URL}${HERO_IMAGE}`}
            alt=""
          />
          <div className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden>
          <div className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <div className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <div className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy">
            <p className="pi-inner-hero__label">Evaluation journey</p>
            <h1 className="pi-inner-hero__title">{car_steps_page.Main_heading}</h1>
            <p className="pi-inner-hero__lead">{car_steps_page.main_heading_desp}</p>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden />
      </header>

      <section className="pi-car-steps__body">
        <div
          className={`pi-car-steps__inner${
            isVehicleEdit ? " pi-car-steps__inner--wizard" : ""
          }`}
        >
          {isVehicleEdit ? (
            <CarUpdateWizard
              inline
              onClose={() => {
                setVehicleEdit(false);
                if (evaluateId) {
                  setapi_loading(true);
                  loadData(evaluateId);
                }
              }}
            />
          ) : isEdit ? (
            <div className="pi-car-steps__edit-panel">
              <div className="pi-car-steps__edit-head">
                <h2>{car_steps_page.Contact_Details}</h2>
                <p>{car_steps_page.Your_Contact_Information}</p>
              </div>

              <div className="pi-car-update__fields">
                <label className="pi-car-update__field">
                  <span>Your name</span>
                  <input
                    type="text"
                    value={name ?? ""}
                    placeholder="Your name"
                    onChange={(e) => setName(e.target.value)}
                  />
                </label>
                <label className="pi-car-update__field">
                  <span>Your email</span>
                  <input
                    type="email"
                    value={email ?? ""}
                    placeholder="example@example.com"
                    onChange={(e) => setemail(e.target.value)}
                  />
                </label>
                <label className="pi-car-update__field">
                  <span>Your mobile number</span>
                  <input
                    type="tel"
                    value={number ?? ""}
                    placeholder="Your mobile number"
                    onChange={(e) => setnumber(e.target.value)}
                  />
                </label>
              </div>

              <div className="pi-car-steps__edit-actions">
                <button
                  type="button"
                  className="pi-car-update__btn pi-car-update__btn--outline"
                  onClick={() => setEdit(false)}
                  disabled={contactSaving}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="pi-car-update__btn pi-car-update__btn--primary"
                  onClick={update_userDetai}
                  disabled={contactSaving}
                >
                  {contactSaving ? "Updating…" : "Update"}
                </button>
              </div>
            </div>
          ) : api_loading ? (
            <div className="pi-car-steps__skeleton" aria-busy="true">
              <ShimmerThumbnail height={140} rounded />
              <ShimmerThumbnail height={140} rounded />
              <ShimmerThumbnail height={140} rounded />
              <ShimmerThumbnail height={140} rounded />
            </div>
          ) : (
            <>
              <div className="pi-car-steps__stage">
                <div className="pi-car-steps__overview">
                <div
                  className="pi-car-steps__overview-ring"
                  style={{ "--pi-journey-progress": `${overallProgress}%` }}
                  aria-hidden
                >
                  <span className="pi-car-steps__overview-ring-inner">
                    <strong>{overallProgress}%</strong>
                    <small>Steps done</small>
                  </span>
                </div>
                <div className="pi-car-steps__overview-copy">
                  <span className="pi-car-steps__overview-eyebrow">Your progress</span>
                  <h2>
                    {completedSteps} of {journeySteps.length} steps finished
                  </h2>
                  <p>
                    Complete each milestone below to move your vehicle through inspection
                    and booking.
                  </p>
                  {vehicleReg ? (
                    <RegPlate
                      value={vehicleReg}
                      country={resolveEvaluationPlateCountry({
                        plateCountry: plate_country,
                        evaluation,
                        reg: vehicleReg,
                      })}
                      className="pi-car-steps__overview-plate"
                    />
                  ) : null}
                </div>
                <div className="pi-car-steps__overview-stats">
                  <div className="pi-car-steps__overview-stat">
                    <span>Photos</span>
                    <strong>
                      {photoCount}/{PHOTO_TARGET}
                    </strong>
                  </div>
                  <div className="pi-car-steps__overview-stat">
                    <span>Vehicle</span>
                    <strong>{vehicleProgress}%</strong>
                  </div>
                  <div className="pi-car-steps__overview-stat">
                    <span>Booking</span>
                    <strong>{appointmentComplete ? "Done" : "Pending"}</strong>
                  </div>
                </div>
              </div>

              <div className="pi-car-steps__journey">
                <div className="pi-car-steps__track" aria-hidden>
                  {journeySteps.map((step, index) => (
                    <React.Fragment key={`track-${step.key}`}>
                      <span
                        className={`pi-car-steps__track-node${
                          (step.progress || 0) >= 100 ? " is-complete" : ""
                        }`}
                      >
                        {(step.progress || 0) >= 100 ? (
                          <BsFillCheckCircleFill size={14} />
                        ) : (
                          index + 1
                        )}
                      </span>
                      {index < journeySteps.length - 1 ? (
                        <span
                          className={`pi-car-steps__track-line${
                            (step.progress || 0) >= 100 ? " is-complete" : ""
                          }`}
                        />
                      ) : null}
                    </React.Fragment>
                  ))}
                </div>

                <div
                  className={`pi-car-steps__list pi-car-steps__list--${journeySteps.length}`}
                >
                  {journeySteps.map((step, index) => (
                    <StepCard
                      key={step.key}
                      stepNumber={index + 1}
                      icon={step.icon}
                      title={step.title}
                      description={step.description}
                      statusLabel={step.statusLabel}
                      statusVariant={step.statusVariant}
                      progress={step.progress}
                      action={step.action}
                      reloadOnTitle={step.reloadOnTitle}
                      onReload={step.onReload}
                      details={step.details}
                      suppressDescription={step.suppressDescription}
                    />
                  ))}
                </div>
              </div>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  mycardata: state.myAppointment.data,
  appointment_update: state.sellMyCar,
  evaluation: state.sellMyCar.evaluation_create,
  plate_country: state.sellMyCar.step2.plate_country,
  book_appointmt_: state.sellMyCar.book_appointmt_,
  step1: state.sellMyCar.step1complete,
  step2: state.cardeailupdate.step2complete,
  car_data: state.cardeailupdate.data,
  divindex: state.cardeailupdate.divindex,
  step3: state.sellMyCar.step3complete,
  evaluation_id_: state.sellMyCar.evaluation_create.id,
  vehicle_details: state.sellMyCar.evaluation_create.vehcile_details,
  total_question: state.sellMyCar.evaluation_create.total_vehicle_question,
  appoinments: state.sellMyCar.evaluation_create.appointment,
  appointment_create: state.sellMyCar.appointment_create,
  vehicle_address: state.sellMyCar.evaluation_create.vehicle_address,
});

const mapDispatchToProps = (dispatch) => ({
  add_car_data: (data) =>
    dispatch({
      type: CAR_DATA_UPDATE_STEPS,
      payload: {
        data: data,
        update: true,
      },
    }),
  syncCredits: (auth) =>
    syncAuthCredits({
      userId: getAuthUserId(auth),
      token: getAuthToken(auth),
      dispatch,
    }),
  showCreditsAlert: (payload) =>
    dispatch({
      type: TOASTER_SHOW,
      payload,
    }),
  update_user_info: (name, email, number) =>
    dispatch({
      type: "update_user_details",
      payload: {
        name: name,
        email: email,
        number: number,
      },
    }),
  set_apointment_data: (data) =>
    dispatch({
      type: SET_APPOINTMENT_DATA,
      payload: {
        data: data,
        update: true,
      },
    }),
  loadVehicleQuestions: (data = {}, id) =>
    dispatch({
      type: CAR_DETAIL_UPDATE,
      payload: {
        type: CAR_DETAIL_UPDATE,
        label: `${Labels.carDetail_Update}?id=${id}`,
        method: GET,
        hideOverlayLoader: true,
        data_vehicle: data,
        requestMeta: { silent: true },
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarSteps);
